import { useSessionPermission } from '@btime/react-session'
import React from 'react'

import { Col, Grid } from '../../../../packages/kiti/components/structure/Grid'
import { DndHandler } from '../../../../components/dnd/DndHandler'
import { useMoveColumnAndSaveScreen } from '../_requests/saveScreen'
import { useOpenEditScreenKanbanColumnModal } from '../../../../utils/routes/modals/modalsActions'
import { useScreen } from '../_load/ScreenLoader'
import Button from '../../../../packages/kiti/components/actions/Button'
import ColumnPanel from './ColumnPanel'
import Draggable from '../../../../components/dnd/Draggable'
import HorizontalDroppable from '../../../../components/dnd/HorizontalDroppable'
import Icon from '../../../../packages/kiti/components/shapes/Icon'
import Scroll from '../../../../packages/kiti/components/helpers/Scroll'
import Separator from '../../../../packages/kiti/components/helpers/Separator'
import Text from '../../../../packages/kiti/components/presentation/Text'

const ColumnsList = props => {
  const screen = useScreen()
  const canEditScreen = useSessionPermission('setupScreen')
  const openEditModal = useOpenEditScreenKanbanColumnModal()
  const [onDrop] = useMoveColumnAndSaveScreen()
  const [sorts, setSorts] = React.useState({})

  return (
    <Scroll scrollX>
      <DndHandler disabled={!canEditScreen}>
        <Grid width="fit-content" align="stretch" gap={1} flex={1}>
          {screen?.data?.columns?.map((column, index) => (
            <HorizontalDroppable
              key={index}
              type="COL"
              onDrop={(from, direction) => onDrop(from, index, direction)}
              placeholderWeight={12}
            >
              <Draggable type="COL" item={{ ...column, index }} hideOnDrag>
                <Col width={20} align="stretch">
                  <ColumnPanel
                    column={column}
                    sort={sorts[column.name] ?? null}
                    setSort={newSort => setSorts(prev => ({ ...prev, [column.name]: newSort }))}
                    index={index}
                    {...props}
                  />
                </Col>
              </Draggable>
            </HorizontalDroppable>
          ))}

          <Col width={20} align="stretch">
            {canEditScreen && (
              <Button
                height={50}
                width={5}
                transparent
                color="light5"
                borderStyle="dashed"
                onClick={() => openEditModal({ id: screen.id })}
              >
                <Separator weight={12} align="center">
                  <Icon name="BsPlusCircle" color="dark2" size={1.2} />
                  <Separator weight={2} />
                  <Text bold color="dark3">
                    Add Coluna
                  </Text>
                </Separator>
              </Button>
            )}
          </Col>
        </Grid>
      </DndHandler>
    </Scroll>
  )
}

export default ColumnsList
